import { gql } from 'apollo-angular';

export const GET_VEHICLE_MODELS = gql`
  query GetVehicleModels($input: VehicleModelSearchInput!) {
    vehicleModels(input: $input) {
      all {
        id
        name
      }
    }
  }
`;
